// Local images — bundled with the app (always correct, no external dependency)
import rSona     from '../assets/images/rice_sona.jpg';
import rBasmati  from '../assets/images/rice_basmati.jpg';
import rHmt      from '../assets/images/rice_hmt.jpg';
import rPonni    from '../assets/images/rice_ponni.jpg';
import rBoiled   from '../assets/images/rice_boiled.jpg';
import oSun      from '../assets/images/oil_sunflower.jpg';
import oGnd      from '../assets/images/oil_groundnut.jpg';
import oPalm     from '../assets/images/oil_palm.jpg';
import dToor     from '../assets/images/dal_toor.jpg';
import dChana    from '../assets/images/dal_chana.jpg';
import dMoong    from '../assets/images/dal_moong.jpg';
import sChilli   from '../assets/images/spice_chilli.jpg';
import sTurmeric from '../assets/images/spice_turmeric.jpg';
import sCoriander from '../assets/images/spice_coriander.jpg';
import fWheat    from '../assets/images/flour_wheat.jpg';
import fMaida    from '../assets/images/flour_maida.jpg';
import fBesan    from '../assets/images/flour_besan.jpg';
import eSalt     from '../assets/images/essential_salt.jpg';
import eSugar    from '../assets/images/essential_sugar.jpg';
import eTea      from '../assets/images/essential_tea.jpg';
import heroImg   from '../assets/images/hero_main.jpg';
import warehouseImg from '../assets/images/section_warehouse.jpg';
import vanImg    from '../assets/images/section_delivery_van.jpg';
import whyVanImg from '../assets/images/why_van.jpg';
import whyPriceImg from '../assets/images/why_price.jpg';
import whyGstImg from '../assets/images/why_gst.jpg';
import whyQualityImg from '../assets/images/why_quality.jpg';
import whySamedayImg from '../assets/images/why_sameday.jpg';
import whyWaImg  from '../assets/images/why_whatsapp.jpg';
import step1Img  from '../assets/images/step_order.jpg';
import step2Img  from '../assets/images/step_pack.jpg';
import step3Img  from '../assets/images/step_van.jpg';
import step4Img  from '../assets/images/step_deliver.jpg';

export const PHOTOS = {
  hero:           heroImg,
  vanDelivery:    whyVanImg,
  wholesaleRates: whyPriceImg,
  gstInvoice:     whyGstImg,
  qualityCheck:   whyQualityImg,
  sameDayDelivery:whySamedayImg,
  whatsappOrder:  whyWaImg,

  sonaRice:     rSona,
  basmatiRice:  rBasmati,
  hmtRice:      rHmt,
  ponniRice:    rPonni,
  boiledRice:   rBoiled,
  sunflowerOil: oSun,
  groundnutOil: oGnd,
  palmOil:      oPalm,
  toorDal:      dToor,
  chanaDal:     dChana,
  moongDal:     dMoong,
  redChilli:    sChilli,
  turmeric:     sTurmeric,
  coriander:    sCoriander,
  wheatFlour:   fWheat,
  maida:        fMaida,
  besan:        fBesan,
  salt:         eSalt,
  sugar:        eSugar,
  tea:          eTea,

  warehouse:    warehouseImg,
  deliveryVan:  vanImg,
  whyVan:       whyVanImg,
  whyPrice:     whyPriceImg,
  whyGST:       whyGstImg,
  whyQuality:   whyQualityImg,
  whySameDay:   whySamedayImg,
  whyWhatsapp:  whyWaImg,
  step1:        step1Img,
  step2:        step2Img,
  step3:        step3Img,
  step4:        step4Img,
  hyderabad:    heroImg,
  shopFront:    heroImg,
  aboutWarehouse: warehouseImg,
  aboutVan:     vanImg,
  aboutRice:    rSona,
};
